import { motion } from "framer-motion";
import { CalendarDays, MapPin } from "lucide-react";

const MONTHS = ["JAN", "FEB", "MRZ", "APR", "MAI", "JUN", "JUL", "AUG", "SEP", "OKT", "NOV", "DEZ"];

function fmt(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;
  return {
    day: String(d.getDate()).padStart(2, "0"),
    month: MONTHS[d.getMonth()],
    year: String(d.getFullYear()),
  };
}

export const Events = ({ events = [] }) => {
  if (!events.length) return null;

  return (
    <div className="mt-6 bg-[#0A0A0A] border border-white/[0.06] p-6 md:p-8" data-testid="events-section">
      <div className="text-[10px] tracking-[0.35em] uppercase text-[#ff0033] font-bold mb-6 flex items-center gap-2">
        <CalendarDays size={13} /> Events
      </div>

      <div className="space-y-3">
        {events.map((e, i) => {
          const d = fmt(e.date);
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`event-${i}`}
              className="grid grid-cols-[80px_1fr] md:grid-cols-[120px_1fr_auto] gap-4 md:gap-6 items-center bg-[#050505] border border-white/10 hover:border-[#ff0033]/40 p-4 md:p-5 transition-colors"
            >
              {/* Logo — permanent farbig, kein grayscale */}
              <div className="flex items-center justify-center min-h-[56px] md:min-h-[64px] bg-[#0A0A0A] border border-white/[0.05] p-2 aspect-square md:aspect-auto md:h-full">
                {e.logo ? (
                  <img
                    src={e.logo}
                    alt={e.title}
                    className="max-h-12 md:max-h-14 max-w-full object-contain"
                  />
                ) : (
                  <CalendarDays size={22} className="text-zinc-700" />
                )}
              </div>

              {/* Info */}
              <div className="min-w-0">
                <div className="font-display font-black uppercase text-lg md:text-2xl tracking-tight text-white leading-tight">
                  {e.title}
                </div>
                {e.location && (
                  <div className="text-[10px] md:text-xs tracking-[0.2em] uppercase text-zinc-500 font-bold mt-1 flex items-center gap-1.5">
                    <MapPin size={11} className="text-[#ff0033]" />
                    {e.location}
                  </div>
                )}
                {e.description && (
                  <div className="text-xs md:text-sm text-zinc-400 mt-2 leading-relaxed">
                    {e.description}
                  </div>
                )}
                {/* Datum mobile */}
                {d && (
                  <div className="mt-3 md:hidden">
                    <span className="inline-flex items-center gap-1.5 border border-[#ff0033]/40 text-[9px] tracking-[0.25em] uppercase font-bold text-white px-2.5 py-1">
                      <CalendarDays size={10} className="text-[#ff0033]" />
                      {d.day}. {d.month} {d.year}
                    </span>
                  </div>
                )}
              </div>

              {/* Datum (Desktop rechts) */}
              {d && (
                <div className="hidden md:flex flex-col items-end shrink-0">
                  <span className="inline-flex items-center gap-2 border border-[#ff0033]/50 text-[10px] tracking-[0.3em] uppercase font-bold text-white px-3.5 py-2">
                    <CalendarDays size={12} className="text-[#ff0033]" />
                    {d.day}. {d.month} {d.year}
                  </span>
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Events;
